<template>
<div>


<div v-if="spinner" class="spinner-grow text-warning " role="status">
  <span class="sr-only">Loading...</span>
</div>  
<div v-else>
<a @click="$emit('close')" style="color:navy" class="float-right pointer">  <i class="fas fa-window-close ml-2" aria-hidden="true"></i></a>    
<div class="table-wrapper-scroll-y my-custom-scrollbar">
<table class="table table-hover table-sm _table-striped mb-0" id="table">
    <thead  >
    <tr>
        
        <th>COLLEZIONE</th>
        <th>TIPO</th>
        <th>NUMERO</th>
        <th>DATA</th>
        <th>SEDE</th>
        <th>CREATO IL</th>        
    </tr>
    </thead>
    <tbody>
      <tr @dblclick="setDocument(item)"  data-toggle="tooltip" title="Doppio click seleziona" class="pointer" v-for="(item,index) in items" :key="index">
        
        <td>{{item.collection_description }}</td>
        <td>{{item.description}}</td>
        <td>{{item.number}}</td>
        <td>{{item.date}}</td>
        <td>{{item.store}}</td>
        <td>{{item.create_at}}</td>                
      </tr>
      </tbody>
    </table>
  </div>  
</div>

</div>
</template>

<script>
import { mapGetters } from 'vuex';

import api                       from '@/api'
import spinner                   from '@/components/common/Spinner.vue';

  export default {

     components: {spinner},
      props : ['supplierId'],
    data () {
      return {
        
        items         : [],
        
        spinner       : false,
        
       }
    },
    watch :
    {

    },
    
  
    computed: {
      
       ...mapGetters(['company']),    
    },

    
    created () 
    {
      this.getData()
    

    },
    methods: 
    {
    
      setDocument(item)
      {

        const obj = {'number':item.number,'date' : item.data_doc,'typeId':item.typeId,'collectionId':item.collectionId}  
        this.$emit('update',obj)

      },
      async getData()
      {

        this.spinner = true
        var data  = {'supplierId'  :  this.supplierId, 'companyId':this.company.Id}
        var sp    = {'sp' : 'spSupplierDocuments'}
        var json  = Object.assign(data, sp);

        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]         
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });



     
  
      },
      
      

    }
  }
</script>

<style scoped>


.pointer:hover
{
  _background-color : blue;
  _color            : white;
  cursor           : pointer;
}


.my-custom-scrollbar {
    position  : relative;
    height    : 150px;
    overflow  : auto;
    }
.table-wrapper-scroll-y {
    display   : block;
  }
p {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
   }
.header {
  font-family : 'Roboto Condensed';
}

 .table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #E8A317;
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    _height       : 40px;

 }
</style>
